// shame.js

(function ($) {

  // noop

})(window.jQuery);
